// Note: keep all keys needed in here even if empty
// DO NOT CHANGE FOR LOCAL DEV --
//    override via app-config.js in the root of the repo (window.__APP_CONFIG) instead
// app-config.js should be a file containing the keys to override in the following format:
// window.__APP_CONFIG = {
//    DYNO_CORE_API_URL: 'https://localhost:5001',
//    DYNO_AUTH0_CLIENTID: 'qweoiu....',
// }
// note them being attached to `window.__APP_CONFIG`
const defaultConfig = {
  APP_BRANDING: 'E360',
  DYNO_CORE_API_URL: 'https://localhost:5001',
  DYNO_ANALYTICS_API_URL: 'https://localhost:6001',
  DYNO_SENSOR_API_URL: 'https://localhost:7001',
  DYNO_DD_APPLICATION_ID: 'no value needed in appsettings.local.json',
  DYNO_DD_CLIENT_ID: 'no value needed in appsettings.local.json',
  DYNO_AUTH0_DOMAIN: 'intech.auth0.com',
  DYNO_AUTH0_AUDIENCE: 'https://api.energy360.com',
  DYNO_AUTH0_CLIENTID: 'put actual value in appsettings.local.json',
  DYNO_APP_CALLBACK_URI: 'http://localhost:3000/callback',
  DYNO_GOOGLE_MAPS_API_KEY: 'put actual value in appsettings.local.json',
  E360_IS_DEMO: '',
  // Feature flags — see configuration/featureFlags.js
  LORA_SCHEDULES: false,
  LORA_ADMIN_DASHBOARD: false,
  TEMPERATURE_CONVERSION_TOOLTIP: false,
  // Forces site-name redaction on; otherwise it is derived from the hostname.
  REDACT_SITE_NAMES: false,
  // Local kill switches. Both stay off here so deployed environments keep the
  // version poll and the unread-messages poll running; turn them on in
  // public/app-config.js when the dev server / local backend makes them noisy.
  DISABLE_VERSION_CHECK: false,
  DISABLE_UNREAD_MESSAGES_POLL: false,
};

// injected at build time, don't change
const buildConfig = {
  BUILD_TAG: 'demo-9cf907',
};

class GlobalConfig {
  constructor() {
    this.config = {
      ...buildConfig,
      ...defaultConfig,
      ...(window.__APP_CONFIG ?? {}),
    };
  }

  get() {
    return this.config;
  }
}

export const globalConfig = new GlobalConfig();
